import { CSSProperties } from 'react';

export const kakaoMapStyles: CSSProperties = {
  height: '100%',
  width: '100%',
};

export const kakaoMapCenter = {
  lat: 37.5003023,
  lng: 126.789494,
};

export const getMapCenter = () =>
  new kakao.maps.LatLng(kakaoMapCenter.lat, kakaoMapCenter.lng);
